import React, { useState } from "react";
import "../CSS/AboutUs.css";
import { sendToWhatsApp } from "./utils/Whatsapp";
import ourstory from "../Img/our-story.png";
import contactFormBg from "../Img/contact-form-bg.png";
import {
  Phone,
  Mail,
  User,
  Smartphone,
  MessageCircle,
} from "lucide-react";
import reason from "../Img/reasons.png";
import { Link } from "react-router-dom";

const AboutUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    inquiry: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const message = `New request Form Submission from About Us page:\n\n*Name:* ${formData.name}\n*Phone:* ${formData.phone}\n*Email:* ${formData.email}\n*Inquiry:* ${formData.inquiry}`;
    sendToWhatsApp(message);
    setFormData({ name: '', phone: '', email: '', inquiry: '' });
  };
  return (
    <div className="about-us-page">
      {/* Hero Section - Only Image */}
      <section className="about-hero-section">
        <div className="about-hero-image">
          <img
            src={ourstory}
            alt="About Us - Cycle Rental"
            className="about-hero-img"
          />
        </div>
      </section>

      <section className="about-content-section">
        <div className="container">
          <div className="about-content-wrapper">
            <p className="about-description">
              Cycle Rental Service is a Bicycle Subscription & Servicing Company focused
              on making cycling an integral part of your daily lives by being
              affordable, accessible and super convenient with a solid team of
              passionate and hard working creative personnels with extremely
              strong core values.
            </p>

            <p className="about-mission">
              Since we all are a part of the problem, we must work towards being
              the solution as well.
            </p>

            <div className="about-tagline">
              Let's <span className="highlight">#TwinTringTogether</span> !
            </div>
          </div>
        </div>
      </section>

      {/* Cycling Solution Section - Content Left, Image Right */}
      <section className="cycling-solution-section">
        <div className="container">
          <div className="cycling-solution-wrapper">
            {/* Left Content */}
            <div className="cycling-solution-content">
              <h2 className="cycling-solution-title">
                Cycling is a solution to multiple problems at once
              </h2>
              <p className="cycling-solution-text">
                In today's time when we are actively facing enormous issues
                relating to environment, health, pollution & congestion on a
                daily basis, cycling is an all inclusive solution.
              </p>
              <p className="cycling-solution-text">
                Since there are restricted & limited opportunities for people to
                engage into cycling apparently, we can proudly say we cracked
                the code.
              </p>
              <p className="cycling-solution-text">
                There isn't a single thing we can't receive on the tap of a
                button, why should accessibility of cycles be the orthodox way?
              </p>
              <div className="cycling-solution-text">
                Simply Subscribe & Receive Your Cycle at your Doorstep !
              </div>
            </div>

            {/* Right Image */}
            <div className="cycling-solution-image">
              <img
                src={reason}
                alt="Cycle at Doorstep"
                className="cycling-solution-img"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section-two-same">
        <div className="container">
          <h2 className="section-title-two-same">
             You are just one step away 
          </h2>
          <p className="cta-subtitle-two-same">
            from getting started on your cycling journey Book Your Cycle   
          </p>
          <Link to="/products" className="cta-button-two-same">
            Book Now →
          </Link>
        </div>
      </section>

      <section className="story-section">
        <div className="story-overlay"></div>
        <div className="container">
          <div className="story-content">
            <h2 className="story-title">Let's have a Chat</h2>

            <div className="story-contact">
              <div className="story-contact-item">
                <Phone size={20} />
                <a href="tel:+918082080816">+91 8082080816</a>
              </div>
              <div className="story-contact-item">
                <Mail size={20} />
                <a href="mailto:cyclerental@gmail.com">cyclerental@gmail.com</a>
              </div>
            </div>

<form className="story-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <User size={18} className="form-icon" />
                <input 
                  type="text" 
                  placeholder="Full Name" 
                  value={formData.name}
                  required
                  onChange={(e) => setFormData({...formData, name: e.target.value})}
                />
              </div>

              <div className="form-group">
                <Smartphone size={18} className="form-icon" />
                <input 
                  type="tel" 
                  placeholder="Mobile Number" 
                  value={formData.phone}
                  required
                  onChange={(e) => setFormData({...formData, phone: e.target.value})}
                />
              </div>

              <div className="form-group">
                <Mail size={18} className="form-icon" />
                <input 
                  type="email" 
                  placeholder="Email" 
                  value={formData.email}
                  required
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                />
              </div>

              <div className="form-group">
                <MessageCircle size={18} className="form-icon" />
                <input 
                  type="text" 
                  placeholder="What are you looking for?" 
                  value={formData.inquiry}
                  onChange={(e) => setFormData({...formData, inquiry: e.target.value})}
                />
              </div>

              <button type="submit" className="story-submit-btn">
                Submit
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
